// removed by extract-text-webpack-plugin
module.exports = {"logo":"_1H92hHPfVJ-QxJ9ZZEOwDq"};


//////////////////
// WEBPACK FOOTER
// ../components/BremenLogo/style.module.less
// module id = 412
// module chunks = 0